module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/semantic-ui-react/~/babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 1500
 ** module chunks = 0
 **/